import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function priceFiltersTriggerPriceBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Current price filters out potential trigger price. Current price:{' '}
        {parsedStatusObj.currentPrice
          ? '$' + ApplyRounding(Number(parsedStatusObj.currentPrice), 2)
          : 'unknown'}
        . Trigger price:{' '}
        {parsedStatusObj.triggerPrice
          ? '$' + ApplyRounding(Number(parsedStatusObj.triggerPrice), 2)
          : 'unknown'}
      </Body3>
    </td>
  );
}
